//CRN_20260420 - ⚠️ ngOnInit() called for components/directives & not services ⚠️

import { DateAndStringResultDTO } from 'src/app/core/interfaces/general/date-and-string-result';
import { EncryptionService } from '../../general/encryption-service';
import { environment } from 'src/environments/environment';
import { eSimApiPaths } from 'src/app/core/consts';
import { ExceptionsService } from '../../general/exceptions-service';
import { HttpClientService } from '../../general/http-client-service';
import { Injectable } from '@angular/core';
import { Observable, of, switchMap } from 'rxjs';
import { StringResultDTO } from 'src/app/core/interfaces/general/string-result';

@Injectable({ providedIn: 'root' })

export class MdmDevicesIntuneStatsService {
  
  constructor(
    private encryptionService: EncryptionService,
    private exceptionsService: ExceptionsService,
    private httpClientService: HttpClientService
  ) { }
      
  public getSyncedByInfo_Latest(companyID: number): Observable<DateAndStringResultDTO> {
    try {
      return this.encryptionService.encrypt_AesServerSideForWeb(<string><unknown>companyID, true)
             .pipe(
                switchMap((encResult: StringResultDTO) => {
                              const companyIdEncSS=encResult.result;
                            
                            return this.httpClientService.get<DateAndStringResultDTO>(environment.eSimApi + 
                                                                                      eSimApiPaths.MdmDevicesIntuneStats + '/' +
                                                                                      eSimApiPaths.MdmDevicesIntuneStatsGetSyncedByInfo_Latest +
                                                                                      "?companyIdEncSS=" + companyIdEncSS,
                                                                                      {}); 
                         })
                  );
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }
      
  public getSyncedByInfo_Previous(companyID: number): Observable<DateAndStringResultDTO> {
    try {
      return this.encryptionService.encrypt_AesServerSideForWeb(<string><unknown>companyID, true)
             .pipe(
                switchMap((encResult: StringResultDTO) => {
                              const companyIdEncSS=encResult.result;
                            
                            return this.httpClientService.get<DateAndStringResultDTO>(environment.eSimApi + 
                                                                                      eSimApiPaths.MdmDevicesIntuneStats + '/' +
                                                                                      eSimApiPaths.MdmDevicesIntuneStatsGetSyncedByInfo_Previous +
                                                                                      "?companyIdEncSS=" + companyIdEncSS,
                                                                                      {}); 
                         })
                  );
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }
}
